import { AutoComplete } from 'primeng/autocomplete';
import { ApiSettings } from '@hub/generated/apiSettings';
import { eContactType, eSearchContactType } from './../../../../_generated/enums';
import { ContactCardGroupDto } from './../../../../_generated/models';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild, forwardRef, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ContactCardComponent } from '@hub/components/v1/_common/contact-cards/contact-card.component';
import { FormEventService } from '@hub/services/form-event.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Subject, Subscription } from 'rxjs';
import { BaseErrorForm } from '@hub/common/BaseErrorForm';
import { Functions } from '@hub/common/Functions';
import { AppConfigService } from '@hub/services/AppConfigService';

const noop = () => { };

export const CUSTOM_INPUTCONPIC_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormContactpickerComponent),
  multi: true
};

@Component({
  selector: 'fm-contactpicker',
  templateUrl: 'form-contactpicker.component.html',
  styles: [
    `
  .contact-picker {
      position: relative;
  }

  .contact-picker .contact-picker--search-icon {
      position: absolute;
      top: 50%;
      right: 7px;
      margin: 0;
      transform: translateY(-50%);
  }

  .contact-picker .contact-picker--unapproved-icon {
    position: absolute;
    top: 6px;
    right: 35px;
    margin: 0;
    margin-top: -3px;
}

  .contact-picker .info-circle-regular {
    cursor: pointer;
  }

  .contactpicker-dropdown{
    display: none;
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    width: 100%;
    max-width: 100%;
    background: white;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
    z-index: 1200;
    overflow: hidden;
    box-sizing: border-box;
  }

  .contactpicker-dropdown .heading-label{
    background: #D6D6D6;
    color: #4296ED;
    margin: -5px -9px;
    padding: 5px 9px;
    cursor: pointer;
  }

  .contactpicker-dropdown .ui-autocomplete-panel{
      position: relative;
      top: 0 !important;
      left: 0 !important;
      display: block !important;
      width: 100% !important;
      max-height: 260px;
      overflow-y: auto;
      overflow-x: hidden;
      box-shadow: none;
      border: 0;
  }
    `
  ],
  encapsulation: ViewEncapsulation.None,
  providers: [CUSTOM_INPUTCONPIC_CONTROL_VALUE_ACCESSOR]
})
export class FormContactpickerComponent extends BaseErrorForm
  implements ControlValueAccessor, OnInit, OnDestroy {

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    public formEventService: FormEventService,
    private appConfigService: AppConfigService
  ) { super(); }

  @Output() completeMethod: EventEmitter<any> = new EventEmitter();
  @Output() onDropdownClick: EventEmitter<any> = new EventEmitter();
  @Output() onSelectValue: EventEmitter<any> = new EventEmitter();
  @Output() onClearMethod: EventEmitter<any> = new EventEmitter();
  @Output() headerClick: EventEmitter<{ contactType: string; contactTypeCount: number; contactTypeId: number }> = new EventEmitter();

  isNotObject: boolean;
  results: Subject<Array<object>> = new Subject<Array<object>>();
  getClicks: Subscription;
  clientDetail: any;
  @Input() forceSelection: boolean = false;
  @Input() resetBtn: boolean = true;
  @Input() isMultiple: boolean = false;
  @Input() isVenue: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public enableTooltip: boolean = true;
  @Input() clearAfterSelect: boolean = false;
  @Input() checkUnapproved: boolean = false;
  @Input() unapprovedMsg = '';
  @Input() isGrouped: boolean = false;
  @Input() showNewContactButton: boolean = false;

  // defaultUserAvatar:string='<i class="far fa-user"></i>'
  tabindex: string;
  @Input('tabindex')
  set tabin(val: string) {
    this.tabindex = String(val);
  }
  private numOfTabs: number = 0;
  private clickEvent: Subject<boolean> = new Subject<boolean>();
  private innerValue: any = '';
  private opcp: OverlayPanel;

  // Placeholders for the callbacks which are later provided
  // by the Control Value Accessor
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  showOverlay = false;
  // @ViewChild(ContactCardComponent) contactCard: ContactCardComponent;
  @ViewChild('content', { read: ElementRef })
  private content: ElementRef;

  @ViewChild('autoComplete') autoComplete: AutoComplete;


  @Input('suggestions')
  set suggestions(val: any[]) {
    if (val && this.isGrouped) {
      let results = [];
      val.forEach((value: ContactCardGroupDto) => {
        if (value.ContactCardDtos.length > 0) {
          let count = value.ContactTypeCount;
          results.push({
            groupName: Functions.toSentenceCase(value.ContactType) + (count ? ` (${count})` : ''),
            isGoupName: true,
            contactType: value.ContactType,
            contactTypeCount: value.ContactTypeCount,
            contactTypeId: value.ContactTypeId
          });
          results = results.concat(value.ContactCardDtos);
        }
      });
      this.results.next(results);
    } else {
      this.results.next(val);
    }
  }

  ngOnInit() {
    this.formEventService.setIndex(parseInt(this.tabindex));
    this.getClicks = this.clickEvent.subscribe(
      x => {
        setTimeout(() => {
          const element: HTMLElement = this.el.nativeElement.querySelector(
            'input'
          );
          if (element != null) {
            element.focus();
          }
        }, 0);
      }
    );
  }

  ngOnDestroy() {
    this.results.complete();
    if (this.getClicks) {
      this.getClicks.unsubscribe();
    }
  }


  handleDropdown(event: any) {
    event.originalEvent.stopPropagation();
    this.onDropdownClick.emit(event);
  }

  search(event: object) {
    this.completeMethod.emit(event);
  }

  get value(): any {
    return this.innerValue;
  }

  // set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(typeof v === 'string' ? null : v);
      if (v && v.Id) {
        this.isNotObject = false;
      } else {
        this.isNotObject = true;
      }
    }
    if (v == '') {
      // this.hideContactCard();
      this.isNotObject = false;
    }
  }

  onClick(event: MouseEvent) {
    event.stopPropagation();
    this.formEventService.changeFocus(this.tabindex);
    this.clickEvent.next(true);
    // this.formEventService.setFocusIn(true);
  }

  resetValue(event: any): void {
    this.writeValue(event);
    this.onChangeCallback(event);
  }

  // Set touched on blur
  onBlur(event) {
    this.validateResulObject();
    this.onTouchedCallback();
  }

  onClear(event: Event) {
    this.onClearMethod.emit(event);
  }

  onSelect(event: Event) {
    this.writeValue(event);
    this.onChangeCallback(event);
    this.onSelectValue.emit(event);
  }

  onFocus(event: Event) {
    this.onTouchedCallback();
  }

  onOverlayShow() {
    this.showOverlay = true;
  }

  onOverlayHide() {
    this.showOverlay = false;
  }

  // From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.innerValue && value !== undefined) {
      this.innerValue = value;
    }
    if (value && value.Id || value === null) {
      this.isNotObject = false;
    }
    if (this.clearAfterSelect && value && value.Id) {
      this.innerValue = null;
    }
  }

  // From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  openUrlAddress() {
    if (!this.isNotObject && this.value) {
      window.open(this.value.ContactConnectUrlAddress, "_blank");
    }
  }

  onSearchIconClick(event: MouseEvent) {
    if (!this.isNotObject && this.value && this.value.ConnectId != null) {
      this.openUrlAddress();
    } else {
      this.preventEvent(event);
      this.headerClick.emit({ contactType: null, contactTypeCount: null, contactTypeId: null });
    }
  }

  preventEvent(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onGroupHeaderClick(event: MouseEvent, value: any) {
    this.preventEvent(event);
    this.autoComplete.hide();
    this.headerClick.emit({ contactType: value.contactType, contactTypeCount: value.contactTypeCount, contactTypeId: value.contactTypeId });
  }

  openCreateNewContact(event: Event) {
    window.open(`${this.appConfigService.getConnectUrl()}-1`, "_blank");
  }

  private validateResulObject() {
    if (typeof this.value === 'string' && this.value !== '') {
      if (this.control && this.control.setErrors && this.control.validator) {
        this.control.setErrors({ 'objectRequired': true });
      }
    }
  }
}
